module.exports = __webpack_public_path__ + "img/herosection-bg02.b50aa649.png";